import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import es from 'vuetify/es5/locale/es'; // Importa el idioma español



Vue.use(Vuetify)

const opts = {
    theme: {
        themes: {
          light: {
            primary: '#AE755F',
            secondary: '#B38C4F',
            accent: "#AE755F",
            error: '#FF5252',
            info: '#2196F3',
            success: '#4CAF50',
            warning: '#FFC107',
          },
        },
      },
      lang: {
        locales: { es },
        current: 'es',
      },
}

// const opts = {
//   theme: { disable: true },
// }

export default new Vuetify(opts)